import { useMemo } from "react";
import { SOURCE_TYPES } from "utils/constants";
import { activationStates } from "variables/activations";

const WizardButtons = ({ state, prevStep, available }) => {
    const source = state?.data?.source;

    const isVerifica = useMemo(() => {
        if (state.step === 5) {
            if (!available) {
                return true;
            }
        }

        if (state.step === 7) {
            if (
                (source === SOURCE_TYPES.RESELLER && !available) ||
                (source !== SOURCE_TYPES.RESELLER && state.data.server_code) ||
                state.status !== activationStates.PENDING_COMPLETION
            ) {
                return true;
            }
        }

        return false;
    }, [state, available]);

    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:gap-5">
            <div>
                {(state.step === 1 && state.id === 0) || state.step !== 1 ? (
                    <button
                        type="button"
                        onClick={prevStep}
                        className="linear bg-transparent w-full rounded-[8px] border border-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-brand-500 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white sm:w-fit"
                    >
                        Indietro
                    </button>
                ) : null}
            </div>

            <div className="text-right">
                <button
                    type="submit"
                    className="linear w-full rounded-[8px] bg-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 sm:w-fit"
                >
                    {isVerifica ? "Verifica" : "Avanti"}
                </button>
            </div>
        </div>
    );
};

export default WizardButtons;
